import LogoIcon from '../../../svgs/LogoIcon';
import { FORTA_BLUE } from '../../../../utils/colors';
import { QUILL_TEXT_COLORS } from '../constants';
import {
  BoldToolbarIcon,
  BulletListToolbarIcon,
  ItalicToolbarIcon,
  OrderedListToolbarIcon,
  TemplateToolbarIcon,
  UnderlineToolbarIcon,
} from './QuillToolbarIcons';

import type { MouseEvent } from 'react';

type QuillToolbarProps = {
  id: string;
  disabled: boolean;
  onSuggest?: () => void;
  suggestDisabled?: boolean;
  suggestLabel: string;
  onTemplate?: () => void;
  templateDisabled?: boolean;
  templateLabel: string;
};

export default function QuillToolbar({
  id,
  disabled,
  onSuggest,
  suggestDisabled,
  suggestLabel,
  onTemplate,
  templateDisabled,
  templateLabel,
}: QuillToolbarProps) {
  const controlsDisabled = disabled;
  const preserveEditorSelection = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <div id={id}>
      {onTemplate ? (
        <span className="ql-formats">
          <button
            type="button"
            className="ql-template"
            aria-label={templateLabel}
            title={templateLabel}
            disabled={templateDisabled || controlsDisabled}
            onMouseDown={preserveEditorSelection}
            onClick={onTemplate}
          >
            <TemplateToolbarIcon className="f-quill-toolbar-icon" />
          </button>
        </span>
      ) : null}
      {onSuggest ? (
        <span className="ql-formats">
          <button
            type="button"
            className="ql-suggest"
            aria-label={suggestLabel}
            title={suggestLabel}
            disabled={suggestDisabled || controlsDisabled}
            onMouseDown={preserveEditorSelection}
            onClick={onSuggest}
          >
            <LogoIcon color={FORTA_BLUE.primary} width={18} height={18} />
          </button>
        </span>
      ) : null}
      <span className="ql-formats">
        <select
          className="ql-color"
          aria-label="Text color"
          defaultValue=""
          disabled={controlsDisabled}
        >
          <option value="" />
          {QUILL_TEXT_COLORS.map((color) => (
            <option key={color} value={color} />
          ))}
        </select>
      </span>
      <span className="ql-formats">
        <button
          type="button"
          className="ql-bold"
          aria-label="Bold"
          disabled={controlsDisabled}
          onMouseDown={preserveEditorSelection}
        >
          <BoldToolbarIcon className="f-quill-toolbar-icon" />
        </button>
        <button
          type="button"
          className="ql-underline"
          aria-label="Underline"
          disabled={controlsDisabled}
          onMouseDown={preserveEditorSelection}
        >
          <UnderlineToolbarIcon className="f-quill-toolbar-icon" />
        </button>
        <button
          type="button"
          className="ql-italic"
          aria-label="Italic"
          disabled={controlsDisabled}
          onMouseDown={preserveEditorSelection}
        >
          <ItalicToolbarIcon className="f-quill-toolbar-icon" />
        </button>
      </span>
      <span className="ql-formats">
        <button
          type="button"
          className="ql-list"
          value="bullet"
          aria-label="Bullet list"
          disabled={controlsDisabled}
          onMouseDown={preserveEditorSelection}
        >
          <BulletListToolbarIcon className="f-quill-toolbar-icon" />
        </button>
        <button
          type="button"
          className="ql-list"
          value="ordered"
          aria-label="Numbered list"
          disabled={controlsDisabled}
          onMouseDown={preserveEditorSelection}
        >
          <OrderedListToolbarIcon className="f-quill-toolbar-icon" />
        </button>
      </span>
    </div>
  );
}
